import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListPlanPrice from './channlListPlanPrice';
import ChannelListUpgradablePlanContainer from '@components/atoms/container/channelListUpgradablePlanContainer';
import ChannelListUpgradablePlanSeparator from '@components/atoms/container/channelListUpgradablePlanSeparator';
import Direction from '@shared/types/enums/direction';
import FlavourConfig from '@shared/config/flavours';
import Focus from '@shared/types/enums/focus';
import Modals from '@shared/types/enums/modals';
import Plan from '@shared/classes/plan';
import UpgradeButton from '../buttons/upgradeButton';
import UpgradablePlan from '../plan/upgradablePlan';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { loginAction } from '@shared/actions/flow';
import { planSelector } from '@shared/store/slices/plans.slice';
import { setModal, setModalParams } from '@shared/store/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '@shared/store/hooks';
import { useCallback, useContext, useMemo } from 'react';
import { userSelector } from '@shared/store/slices/user.slice';

interface Props {
  plan?: Plan;
}

export default function ChannelListUpgradablePlan({ plan }: Props) {
  const dispatch = useAppDispatch();
  const user = useAppSelector(userSelector);
  const { data } = useAppSelector(planSelector);
  const { focus } = useAppSelector(focusSelector);
  const { channel } = useContext(ChannelListContext);
  const price = useMemo(() => {
    const parsedPrice =
      FlavourConfig.showPrice && user.carrierId === FlavourConfig.carrierId
        ? (
            plan?.price ||
            data?.find((item) => item.id === plan?.id)?.planSubscription
              ?.subscriptionPeriodicity?.mensual?.amount
          )?.toString()
        : null;
    return parsedPrice ? parseFloat(parsedPrice) : null;
  }, [data, plan]);

  const openUpgradeModal = useCallback(() => {
    dispatch(
      setModalParams({
        channel,
        plan,
      })
    );
    dispatch(setModal(Modals.UPGRADE_PLAN));
  }, [channel, plan]);

  return (
    <ChannelListUpgradablePlanContainer
      id={'channelListUpgradablePlanContainer'}
    >
      {plan?.name ? (
        <>
          <UpgradablePlan
            direction={Direction.VERTICAL}
            fontSize={42}
            plan={plan}
          />
          <ChannelListUpgradablePlanSeparator />
        </>
      ) : null}
      <UpgradeButton
        forceFocus={focus === Focus.CHANNEL_LIST_UPGRADE}
        height={90}
        margin={'unset'}
        index={0}
        item={TranslationManager.get('MODAL.UPGRADE_PLANS.BUTTONS.WANT_IT')}
        releaseAction={user.isAnonymous ? loginAction : openUpgradeModal}
      />
      {price ? (
        <>
          <ChannelListUpgradablePlanSeparator
            id={'channelListUpgradablePlanSeparator'}
          />
          <ChannelListPlanPrice price={price} />
        </>
      ) : null}
    </ChannelListUpgradablePlanContainer>
  );
}
